/**
*****************************************
*										*
* NAGARRO  - CSX - CONFIDENTIAL         *
*										*
*****************************************
*/

import { RouterModule, Routes } from '@angular/router';

import { CanDeactivateViaEditGuardService } from './../core/services/can-deactivate-via-edit-guard.service';
import { LmsTrainComponent } from './train.component';
import { LmsTrainDataComponent } from './data/train-data.component';
import { LmsTrainHistoryComponent } from './history/train-history.component';
import { LmsTrainNotesComponent } from './notes/train-notes.component';
import { LmsTrainProfileComponent } from './profile/train-profile.component';
import { NgModule } from '@angular/core';
import { TrainDataResolver } from './shared/train-data.resolver';
import { TrainHistoryResolver } from './shared/train-history.resolver';
import { TrainNotesResolver } from './shared/train-notes.resolver';
import { TrainProfileResolver } from './shared/train-profile.resolver';

const trainRoutes: Routes = [
    {
        path: 'train',
        component: LmsTrainComponent,
        data: { tab: 'Train' },
        children: [
            // {
            //     path: '',
            //     redirectTo: 'data',
            //     pathMatch: 'full',
            //     canDeactivate: [CanDeactivateViaEditGuardService]
            // },
            {
                path: 'data',
                component: LmsTrainDataComponent,
                data: { tab: 'Train' },
                resolve: {
                    tabData: TrainDataResolver
                },
                canDeactivate: [CanDeactivateViaEditGuardService]
            },
            {
                path: 'data/:tabid',
                component: LmsTrainDataComponent,
                data: { tab: 'Train' },
                resolve: {
                    tabData: TrainDataResolver
                },
                canDeactivate: [CanDeactivateViaEditGuardService]
            },
            {
                path: 'data/:tabid/:search',
                component: LmsTrainDataComponent,
                data: { tab: 'Train' },
                resolve: {
                    tabData: TrainDataResolver
                },
                canDeactivate: [CanDeactivateViaEditGuardService]
            },
            {
                path: 'data/:tabid/:search/:time',
                component: LmsTrainDataComponent,
                data: { tab: 'Train' },
                resolve: {
                    tabData: TrainDataResolver
                },
                canDeactivate: [CanDeactivateViaEditGuardService]
            },
            {
                path: 'history',
                component: LmsTrainHistoryComponent,
                data: { tab: 'Train' },
                resolve: {
                    tabData: TrainHistoryResolver
                }
                // canDeactivate: [CanDeactivateViaEditGuardService]
            },
            {
                path: 'history/:tabid',
                component: LmsTrainHistoryComponent,
                data: { tab: 'Train' },
                resolve: {
                    tabData: TrainHistoryResolver
                }
                // canDeactivate: [CanDeactivateViaEditGuardService]
            },
            {
                path: 'history/:tabid/:search',
                component: LmsTrainHistoryComponent,
                data: { tab: 'Train' },
                resolve: {
                    tabData: TrainHistoryResolver
                }
                // canDeactivate: [CanDeactivateViaEditGuardService]
            },
            {
                path: 'notes',
                component: LmsTrainNotesComponent,
                data: { tab: 'Train' },
                resolve: {
                    tabData: TrainNotesResolver
                },
                canDeactivate: [CanDeactivateViaEditGuardService]
            },
            {
                path: 'notes/:tabid',
                component: LmsTrainNotesComponent,
                data: { tab: 'Train' },
                resolve: {
                    tabData: TrainNotesResolver
                },
                canDeactivate: [CanDeactivateViaEditGuardService]
            },
            {
                path: 'notes/:tabid/:search',
                component: LmsTrainNotesComponent,
                data: { tab: 'Train' },
                resolve: {
                    tabData: TrainNotesResolver
                },
                canDeactivate: [CanDeactivateViaEditGuardService]
            },
            {
                path: 'profile',
                component: LmsTrainProfileComponent,
                data: { tab: 'Train' },
                resolve: {
                    tabData: TrainProfileResolver
                },
                canDeactivate: [CanDeactivateViaEditGuardService]
            },
            {
                path: 'profile/:tabid',
                component: LmsTrainProfileComponent,
                data: { tab: 'Train' },
                resolve: {
                    tabData: TrainProfileResolver
                },
                canDeactivate: [CanDeactivateViaEditGuardService]
            },
            {
                path: 'profile/:tabid/:search',
                component: LmsTrainProfileComponent,
                data: { tab: 'Train' },
                resolve: {
                    tabData: TrainProfileResolver
                },
                canDeactivate: [CanDeactivateViaEditGuardService]
            },
        ]
    }
];

/**
 * @export
 * @class TrainRoutingModule
 */
@NgModule({
    imports: [
        RouterModule.forChild(trainRoutes)
    ],
    exports: [
        RouterModule
    ]
})
export class TrainRoutingModule {

}
